import { setTemaGeral } from "../Utils/SetTemaGeral";

const INITIAL_STATE = {
  isDefault: true,
  isCustom: false,
  isDark: localStorage.getItem("THEME_DARK") === "true"
};

const nomeDef = "PDV";

export default (state = INITIAL_STATE, action) => {
  const isDark = action.isDark;
  switch (action.type) {
    case 'THEME_DEFAULT':
      document.title = nomeDef;
      document.getElementById("favicon").setAttribute("href", "/favicon-smt.ico");

      setTemaGeral("THEME_DEFAULT", null, isDark);
      localStorage.setItem("THEME_DARK", isDark);

      state = INITIAL_STATE;
      return { ...state, isDark };
    case 'THEME_CUSTOM':
      const layout = action.layout;
      document.title = layout.nome + " - PDV";
      const temaClaro = layout.claro;
      const temaEscuro = layout?.escuro;
      var isDarkInternal = isDark && !!layout.escuro;
      const temaToSet = isDarkInternal ? temaEscuro : temaClaro;

      localStorage.setItem("THEME_DARK", isDarkInternal ? true : null);

      setTemaGeral('THEME_CUSTOM', temaToSet, isDarkInternal);

      const icone = temaToSet?.icone;
      if (icone)
        document.getElementById("favicon").setAttribute("href", icone);


      state = { isDefault: false, isCustom: true, nome: layout.nome, logo: temaToSet?.logo, icone, claro: temaClaro, escuro: temaEscuro, isDark };
      return state;
    case 'SETCADASTRO':
      setTemaGeral("THEME_DEFAULT", null, false);
      return INITIAL_STATE;
    case 'LOGOUT':
      setTemaGeral("THEME_DEFAULT", null, isDark);
      return INITIAL_STATE;
    default:
      return state;
  }
};